// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContainerDiv {
    border: 2px solid var(--ContainerBorderColor);
    background-color: var(--ContainerBackgroung);
    padding: 1em;
    border-radius: 10px;
    margin-top: 0.5em;
    min-height: 2em;
    animation: fadeInGlobal 1s;
}

.ContainerDivBorder {
    border: 2px solid var(--ContainerBorderColor);
    background-color: var(--ContainerBackgroung);
    padding: 1em;
    border-radius: 10px;
    margin-top: 0.5em;
    min-height: 2em;
    border:1px solid var(--GrayBlue) ;
    animation: fadeInGlobal 1s;
}
.ContainerDivIsInContainer {
    border: 2px solid var(--ContainerInContainerBorder);
    background-color: var(--ContainerInContainerBackground);
    padding: 1em;
    border-radius: 10px;
    margin-top: 0.5em;
    min-height: 2em;
}

.ContainerDivNoBackground {
    border-radius: 10px;
    margin-top: 0.5em;
    min-height: 2em;
    min-width: 20em;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    animation: moveRightGlobal 0.5s linear;
}

.ContainerDivNoBackgroundAnimationLeft {
    border-radius: 10px;
    margin-top: 0.5em;
    min-height: 2em;
    min-width: 20em;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    animation: moveLeftGlobal 0.5s linear;
}

.ContainerDivNoBackgroundNoAnimation {
    border-radius: 10px;
    margin-top: 0.5em;
    min-height: 2em;
    min-width: 20em;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    overflow-x: none;
}

.ContainerDisplayTitle {
    text-align: center;
    color: white;
}

.ContainerHeadLine {
    height: 3px;
    background-color: var(--ContainerHeadLineColor);
    border: none;
}

.DynamicContainerMain {
    display: grid;
    grid-auto-rows: minmax(100px, auto);
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    grid-gap: 1em;
    justify-items: center;
    justify-items: stretch;
    padding: 20px 20px;
    overflow: hidden;
}

.DynamicContainer {
    /* max-width: var(--maxMiddelContainerWidth);  */
    display: inline-block;
    padding: 0px 10px;

    background-color: var(--ContainerBackgroung);
    border-radius: 10px;
    animation: moveLeftGlobal 1s;
}

@media only screen and (max-width: 768px) {
    .ContainerDiv span,
    p,
    a {
        font-size: 11px;
    }

    .ContainerDivIsInContainer span,
    p,
    a {
        font-size: 11px;
    }

    .ContainerDivNoBackground span,
    p,
    a {
        font-size: 11px;
    }

    .ContainerDivNoBackgroundAnimationLeft span,
    p,
    a {
        font-size: 11px;
    }

    .ContainerDivNoBackgroundNoAnimation span,
    p,
    a {
        font-size: 11px;
    }

    .DynamicContainerMain {
        padding: 1em;
        padding-right: 0.5em;
        overflow-x: hidden;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Container/Container.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;IAC7C,4CAA4C;IAC5C,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,6CAA6C;IAC7C,4CAA4C;IAC5C,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,0BAA0B;AAC9B;AACA;IACI,mDAAmD;IACnD,uDAAuD;IACvD,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,2DAA2D;IAC3D,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,qBAAqB;IACrB,iBAAiB;;IAEjB,4CAA4C;IAC5C,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI;;;QAGI,eAAe;IACnB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,oBAAoB;QACpB,kBAAkB;IACtB;AACJ","sourcesContent":[".ContainerDiv {\n    border: 2px solid var(--ContainerBorderColor);\n    background-color: var(--ContainerBackgroung);\n    padding: 1em;\n    border-radius: 10px;\n    margin-top: 0.5em;\n    min-height: 2em;\n    animation: fadeInGlobal 1s;\n}\n\n.ContainerDivBorder {\n    border: 2px solid var(--ContainerBorderColor);\n    background-color: var(--ContainerBackgroung);\n    padding: 1em;\n    border-radius: 10px;\n    margin-top: 0.5em;\n    min-height: 2em;\n    border:1px solid var(--GrayBlue) ;\n    animation: fadeInGlobal 1s;\n}\n.ContainerDivIsInContainer {\n    border: 2px solid var(--ContainerInContainerBorder);\n    background-color: var(--ContainerInContainerBackground);\n    padding: 1em;\n    border-radius: 10px;\n    margin-top: 0.5em;\n    min-height: 2em;\n}\n\n.ContainerDivNoBackground {\n    border-radius: 10px;\n    margin-top: 0.5em;\n    min-height: 2em;\n    min-width: 20em;\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n    animation: moveRightGlobal 0.5s linear;\n}\n\n.ContainerDivNoBackgroundAnimationLeft {\n    border-radius: 10px;\n    margin-top: 0.5em;\n    min-height: 2em;\n    min-width: 20em;\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n    animation: moveLeftGlobal 0.5s linear;\n}\n\n.ContainerDivNoBackgroundNoAnimation {\n    border-radius: 10px;\n    margin-top: 0.5em;\n    min-height: 2em;\n    min-width: 20em;\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n    overflow-x: none;\n}\n\n.ContainerDisplayTitle {\n    text-align: center;\n    color: white;\n}\n\n.ContainerHeadLine {\n    height: 3px;\n    background-color: var(--ContainerHeadLineColor);\n    border: none;\n}\n\n.DynamicContainerMain {\n    display: grid;\n    grid-auto-rows: minmax(100px, auto);\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    grid-gap: 1em;\n    justify-items: center;\n    justify-items: stretch;\n    padding: 20px 20px;\n    overflow: hidden;\n}\n\n.DynamicContainer {\n    /* max-width: var(--maxMiddelContainerWidth);  */\n    display: inline-block;\n    padding: 0px 10px;\n\n    background-color: var(--ContainerBackgroung);\n    border-radius: 10px;\n    animation: moveLeftGlobal 1s;\n}\n\n@media only screen and (max-width: 768px) {\n    .ContainerDiv span,\n    p,\n    a {\n        font-size: 11px;\n    }\n\n    .ContainerDivIsInContainer span,\n    p,\n    a {\n        font-size: 11px;\n    }\n\n    .ContainerDivNoBackground span,\n    p,\n    a {\n        font-size: 11px;\n    }\n\n    .ContainerDivNoBackgroundAnimationLeft span,\n    p,\n    a {\n        font-size: 11px;\n    }\n\n    .ContainerDivNoBackgroundNoAnimation span,\n    p,\n    a {\n        font-size: 11px;\n    }\n\n    .DynamicContainerMain {\n        padding: 1em;\n        padding-right: 0.5em;\n        overflow-x: hidden;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
